// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

myw.MbTilesLayer = L.TileLayer.extend({
    /**
     * @class MbTiles specific map tile layer for tiles accessed in an Mbtiles format.
     * Comparing with the standard web tiles format, the MbTiles format flips the y coordinate of a tile
     * Extends {@link http://leafletjs.com/reference.html#tilelayer|L.TileLayer}
     * @constructs
     * @param  {string} url     The base url for obtaining tiles
     * @param  {object} options Options as specified for {@link http://leafletjs.com/reference.html#tilelayer|L.TileLayer}
     */
    initialize(url, options) {
        L.TileLayer.prototype.initialize.call(this, `${options.tileBaseUrl}?${url}`, options);
    },

    getTileUrl(tilePoint, zoom, tile) {
        const z = this._getZoomForUrl(zoom);
        const y = Math.pow(2, z) - tilePoint.y - 1;
        const url = `${this._url}&z=${z}&x=${tilePoint.x}&y=${y}`;
        return url;
    }
});

export default myw.MbTilesLayer;
